import React, { useState ,useRef, useEffect } from "react";
import { Link } from "gatsby";
import { Container, Row, Col, Breadcrumb, Modal } from "react-bootstrap";
import GoogleMapReact from "google-map-react";
import HTMLReactParser from "html-react-parser";
import {Helmet } from "react-helmet"
import { useLocation } from "@reach/router"
import axios from "axios";
import review from '../../images/review-mob.svg';
import reviewTab from '../../images/review-tab.svg';
import ContactCard from "../ContactCard/ContactCard";
import TeamCard from "../TeamCard/TeamCard";
import BrandLogo from "../../images/logo.svg";
import OfficeBookAppointment from "./OfficeBookAppointment";
import ImageTransform from "../common/ggfx-client/module/components/image-transform";
import { removeEmptyHeadings } from "../common/htmlUtils";
import "./OfficeDetail.scss";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
import { FacebookIcon, LinkedinIcon, TwitterIcon, WhatsappIcon } from "react-share";
import { GetURL, getVideoId } from "../utils";
import ContactFormPage from "../forms/contact";
import $ from "jquery";
import { isMobile } from "react-device-detect";
import '../NewsEvents/NewsEvents.scss'
import NewsCard from '../NewsCard/NewsCard';
import GoogleMap from "./GoogleMap";
import Counter from "../Counter/Counter";
import Faq from "../Faq/Faq";
import NearbyAreas from "../NearbyAreas/NearbyAreas";
import Slider from "react-slick";
import { graphql, useStaticQuery } from 'gatsby';
import {PageLinks} from '../../components/common/constant';
import PlayVideo from '../PlayVideo/PlayVideo';

// Header component

const Marker = () => <img src={BrandLogo}/>;

const OfficeDetail = (props) => {
    console.log("OfficeDetailprops", props);
     const [isPlay, setPlay] = useState(false);
     const [selectedVideo, setSelectedVideo] = useState("");
     const [show, setShow] = useState(false);
     const [isSticky, setIsSticky] = useState(false);
     const bannerRef = useRef(null);

    useEffect(() => {
        const bannerEl = bannerRef.current;
       if (!bannerEl) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
               // banner not visible => show sticky CTA
               setIsSticky(!entry.isIntersecting);            },
            { threshold: 0 }
       );
        observer.observe(bannerEl);
        return () => observer.disconnect();
    }, []);

    var { pathname } = useLocation()
    var ofcUrl = process.env.GATSBY_SITE_URL + pathname

    const isKensington =
        props?.officeType === "kensington" ||
        props?.data?.Url === "estate-agents-in-kensington" ||
        props?.data?.Alias?.toLowerCase()?.includes("kensington") ||
        pathname?.includes("estate-agents-in-kensington");

    const officeConfig = isKensington
        ? {
              name: "Kensington",
              placeUri: "ChIJvQp4RIsPdkgRmjSz3DX8SmU",
              businessListingUrl: "https://maps.app.goo.gl/Djnm6vPAQ3aWhREd7",
              locationUrl: "https://maps.app.goo.gl/zMvHBJRLb4pucjLg7",
              defaultRating: "4.7",
          }
        : {
              name: "Chelsea",
              placeUri: "ChIJB4BYzYsPdkgRGKlEwr-GUCU",
              businessListingUrl: "https://maps.app.goo.gl/e2EZ6J76Ljwpseax7",
              locationUrl: "https://maps.app.goo.gl/Z64fdCayEW3UD4i37",
              defaultRating: "4.8",
          };

    const [googleRating, setGoogleRating] = useState(officeConfig.defaultRating);

    useEffect(() => {
        let isMounted = true;
        setGoogleRating(officeConfig.defaultRating);

        const fetchGoogleRating = async () => {
            try {
                const res = await axios.get(
                    `https://service-reviews-ultimate.elfsight.com/data/sources?uris[]=${officeConfig.placeUri}`
                );
                const sourceData = res?.data?.result?.data?.[0];
                if (isMounted && sourceData?.rating) {
                    setGoogleRating(Number(sourceData.rating).toFixed(1));
                }
            } catch (error) {
                console.error("Failed to load Google rating:", error);
            }
        };

        fetchGoogleRating();

        return () => {
            isMounted = false;
        };
    }, [officeConfig.placeUri, officeConfig.defaultRating]);

    let processedImages = JSON.stringify({});
    if (props?.data?.imagetransforms?.Tile_Image_Transforms) {
        processedImages = props?.data?.imagetransforms?.Tile_Image_Transforms;
    }

    const shareurl = typeof window !== "undefined" ? window.location.href : "";

    const [shareIcons, setShareicons] = React.useState(false);

    const openShareicons = () => {
        setShareicons(true)
        if (shareIcons === true) {
            setShareicons(false)
        }
    }

    const faqModuleData = props?.data?.Modules?.find(
    (m) =>
        props?.data?.Title &&
        m?.Anchor_Id &&
        props.data?.Title.toLowerCase().includes(m?.Anchor_Id.toLowerCase())
    );
    //console.log("faqModuleData:", faqModuleData);

    const data = useStaticQuery(graphql`
        query {
            glstrapi {
                newsAndVideos (sort: "Sort") {
                    _id
                    Title
                    Url
                    Category {
                        Title
                    }
                    Tile_Image {
                        alternativeText
                        url
                    }
                    Video_Url
                    Sub_Category
                    imagetransforms
                }
            }
        }
    `)
    const trackerShare = event => {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
            event: "Share - social icons",
            formType: event + " - " + shareurl,
            formId: "Share",
            formName: "Share",
            formLabel: "Share",
        })
    }
    var settings = {
        dots: true,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 2000,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ]
    };
    let schemaAddress;
    let schemaLocality;
    let schemaPostalCode;
    let keywords;
    let ratingValue;
    let reviewCount;
    let areaserved;
    let skuVal;
    if(props?.data?.Alias?.includes("Chelsea")){
        schemaAddress = "13 Crescent Place"
        schemaLocality = "Chelsea"
        schemaPostalCode = "SW3 2EA"
        keywords = "Chelsea estate agents, estate agents in Chelsea"
        areaserved = "W8, SW3, SW5, SW7, SW10, Fulham, Kensington, Hammersmith, Earls Court, Knightsbridge, South Kensington, Royal Borough of Kensington and Chelsea."
        ratingValue = googleRating || "4.8"
        reviewCount = "280"
        skuVal = "tlc-CHELSEA-SERVICES"
    }
    if(props?.data?.Alias?.includes("Kensington")){
        schemaAddress = "8 Hogarth place"
        schemaLocality = "Kensington, London"
        schemaPostalCode = "SW5 0QT"
        keywords = "Estate agents in Kensington, Kensington estate agents, letting agents in Kensington, Kensington letting agents"
        areaserved = "Kensington, Chelsea, Earl's Court, and the surrounding areas, including W8, SW5, SW7, SW10, and SW3"
        ratingValue = googleRating || "4.7"
        reviewCount = "403"
        skuVal = "tlc-KENSINGTON-SERVICES"
    }
    var Lets_Together_Content = props?.globalContent?.Lets_Work_Together

    return (
        <React.Fragment>
            <Helmet>
                <script type="application/ld+json">{`{
                    "@context": "https://schema.org",
                    "@type": "RealEstateAgent",
                    "name": "${props?.data?.Meta_Title}",
                    "@id": "${ofcUrl}",
                    "url": "${ofcUrl}",
                    "telephone": "${props?.data?.Phone}",
                    "description": "${props?.data?.Meta_Description}",
                    "logo": "${BrandLogo}",
                    "keywords": "${keywords}",
                    "areaServed": "${areaserved}",
                    "address": {
                      "@type": "PostalAddress",
                      "streetAddress": "${schemaAddress}",
                      "addressLocality": "${schemaLocality}",
                      "postalCode": "${schemaPostalCode}",
                      "addressCountry": "United Kingdom"
                    },
                    "geo": {
                      "@type": "GeoCoordinates",
                      "latitude": ${props?.data?.Latitude},
                      "longitude":${props?.data?.Longitude}
                    },
                    "openingHoursSpecification": [{
                      "@type": "OpeningHoursSpecification",
                      "dayOfWeek": [
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday"
                      ],
                      "opens": "09:00",
                      "closes": "18:00"
                    }],
                    "aggregateRating": {
                     "@type": "AggregateRating",
                     "ratingValue": "${ratingValue}",
                     "reviewCount": "${reviewCount}"
                      },
                    "sameAs": [
                      "https://www.facebook.com/tlcREALestateagents",
                      "https://twitter.com/tlcestateagents",
                      "https://instagram.com/tlcestateagents",
                     "https://www.youtube.com/channel/UC7wmgcJX1xgWru_EB--b0UQ",
                      "https://www.linkedin.com/company/tylden-lofts-and-calvert"
                      ]                   
                }`}
                </script>  
                <script type="application/ld+json">{`{
                       "@context": "https://schema.org/", 
                        "@type": "Product", 
                        "name": "${props?.data?.Alias}",
                        "description": "${props?.data?.Meta_Description}", 
                        "image": "${BrandLogo}", 
                       "sku": "${skuVal}",
                        "category": "Real Estate Services", 
                        "offers": { 
                            "@type": "Offer", 
                            "url": "${ofcUrl}", 
                            "priceCurrency": "GBP", 
                            "price": "0", 
                            "availability": "https://schema.org/InStock", 
                            "itemCondition": "https://schema.org/NewCondition" 
                        }, 
                        "aggregateRating": { 
                            "@type": "AggregateRating", 
                            "ratingValue": "${ratingValue}", 
                            "reviewCount": "${reviewCount}" 
                        }, 
                        "brand": { 
                            "@type": "Organization", 
                            "name": "tlc London", 
                            "address": { 
                            "@type": "PostalAddress", 
                            "streetAddress": "${schemaAddress}", 
                            "addressLocality": "${schemaLocality}", 
                            "postalCode": "${schemaPostalCode}", 
                            "addressCountry": "GB" 
                            }, 

                            "telephone": "+44 20 7370 4000" 
                        } 
                }`}

                    
               </script>  
            </Helmet>
            <section className="office-detail">
                <Container>
                    <Row>
                        <Col md={12} className="bio-wrapper" ref={bannerRef}>
                            <div className="bio-img">
                                <ImageTransform
                                    imagesources={props?.data?.Tile_Image?.url}
                                    renderer="pic-src" imagename="offices.Tile_Image.tile"
                                    attr={{ alt: props?.data?.Tile_Image?.alternativeText ? props?.data?.Tile_Image?.alternativeText : props?.data?.Title, className: 'm-0' }}
                                    imagetransformresult={processedImages}
                                    id={props?.data?._id}
                                />
                                {(props?.data?.Video_Url && !isPlay) && <i className="video-icon cursor-pointer" onClick={() => setPlay(true) }></i>}
                                {(props?.data?.Video_Url && isPlay) && <div className="fullscreen-video">
                                    {isPlay && 
                                        <React.Fragment>
                                            <div className="d-block">
                                                <PlayVideo
                                                    isOpen={isPlay}
                                                    videoId={props?.data?.Video_Url}
                                                    stopPlay={setPlay}
                                                    width={'100%'} height={'100%'}
                                                    fullscreen={true}
                                                />
                                            </div>
                                        </React.Fragment>
                                    }
                                </div>}
                            </div>
                            <div className="bio-details-wrapper">
                                <div className="bio-details">
                                    <h1>
                                        {props?.data?.Title}
                                    </h1>
                                    <span className="sm-info">{props?.data?.Address}</span>
                                    {/* <span className="sm-info text-underline ps-3 cursor-pointer" onClick={() => {
                                        $('html, body').animate({
                                            scrollTop: $("#office-map").offset().top-130
                                        }, 0)
                                    }}><u>View Map</u></span> */}
                                    <div className="contact-info">
                                        <a href="javascript:;" className="btn  d-block" onClick={() => setShow(true)}>
                                            get in touch
                                        </a>
                                        <div className="info">
                                            <a href="javascript:;" onClick={() => setShow(true)} className=" mail phone  d-flex cursor-pointer"> 
                                           
                                                <i className="icon-phone-grey"></i>
                                                {props?.data?.Phone}
                                            </a>
                                            <a href="javascript:;" onClick={() => setShow(true)} className=" mail phone  d-flex cursor-pointer"> 
                                                <i className="icon-mail"></i>
                                                <span>{props?.data?.Email}</span>
                                            </a>
                                            <a href="javascript:;" className="mail cursor-pointer position-relative share-container">
                                                <i className="icon-share" onClick={openShareicons}></i>
                                                <span onClick={openShareicons}>Share</span>
                                                <div className="position-absolute">
                                                    {shareIcons && (
                                                        <div onClick={openShareicons} className="d-flex flex-row property-share-social-icons2 mobile-details-socila-share ps-3">
                                                            <FacebookShareButton
                                                                onClick={() =>
                                                                    trackerShare("FacebookShareButton")
                                                                }
                                                                url={shareurl}
                                                                className="my-share-button facebook-share mx-1"
                                                            >
                                                                <FacebookIcon
                                                                    size={32}
                                                                    round={false}
                                                                    borderRadius={`10`}
                                                                />
                                                            </FacebookShareButton>
                                                            <TwitterShareButton
                                                                onClick={() =>
                                                                    trackerShare("TwitterShareButton")
                                                                }
                                                                url={shareurl}
                                                                className="my-share-button twitter-share mx-1"
                                                            >
                                                                <TwitterIcon
                                                                    size={32}
                                                                    round={false}
                                                                    borderRadius={`10`}
                                                                />
                                                            </TwitterShareButton>
                                                            <LinkedinShareButton
                                                                onClick={() =>
                                                                    trackerShare("LinkedinShareButton")
                                                                }
                                                                url={shareurl}
                                                                className="my-share-button linkedin-share mx-1"
                                                            >
                                                                <LinkedinIcon
                                                                    size={32}
                                                                    round={false}
                                                                    borderRadius={`10`}
                                                                />
                                                            </LinkedinShareButton>
                                                            <WhatsappShareButton
                                                                onClick={() =>
                                                                    trackerShare("WhatsappShareButton")
                                                                }
                                                                url={shareurl}
                                                                className="my-share-button whatsapp-share mx-1"
                                                            >
                                                                <WhatsappIcon
                                                                    size={32}
                                                                    round={false}
                                                                    borderRadius={`10`}
                                                                />
                                                            </WhatsappShareButton>    
                                                        </div>
                                                    )}
                                                </div>
                                            </a>
                                            <a href={officeConfig.locationUrl} target="blank" className=" mail phone d-flex cursor-pointer"> 
                                                <i className="icon-location"></i>
                                                Location
                                            </a>
                                        </div>

                                        {/* <div className="contact-us">
                                            <span className="talk-us">
                                                Talk to me in:

                                            </span>
                                            <div className="country">
                                                <img src={france} alt="france" />
                                            </div>

                                            <div className="country">
                                                <img src={china} alt="china" />
                                            </div>
                                        </div> */}
                                    </div>

                                </div>
                            </div>
                        </Col>
                        <Col md={12} lg={6} className="top-content ">
                            {props?.data?.Opening_Hours && <div className="content-wrapper opening-hours"><hr className="hr"/>
                                {HTMLReactParser(removeEmptyHeadings(props?.data?.Opening_Hours))}
                            </div>}<hr className="hr"/>
                            <a
                                href={officeConfig.businessListingUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="review-wrap-link"
                                aria-label={`View tlc ${officeConfig.name} on Google Reviews and Google Maps`}
                            >
                                <div className="review-wrap">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <picture>
                                                        <source media='(min-width: 768px)' srcSet={reviewTab}/>
                                                        <img src={review} alt="Google Reviews" />
                                                    </picture>
                                                </td>
                                                <td>
                                                    <div className="text-wrap td office-review">Rated <strong>{googleRating} out of 5</strong> from our valued customers.</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </a>
                            <br></br>
                            <hr className="hr"/>
                        </Col>
                        <div className="content-wrapper">
                                <Row >
                                    <Col xs={12} lg={6}>
                                        <div>
                                            {props?.data?.Content_Heading && <h2 className="content-heading">{props?.data?.Content_Heading}</h2>}
                                            {props?.data?.Content && HTMLReactParser(removeEmptyHeadings(props?.data?.Content))}
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={6}>
                                      <GoogleMap mapLink={props?.data?.Map_Link}/>
                                      <NearbyAreas slug={props?.data.Url} />
                                    </Col>
                                </Row>
                            </div>
                            
                            {props?.data?.Select_Team_Member &&
                            <div>
                              <Row>
                                <Col>
                                    <ContactCard
                                    blockImg={props?.data?.Select_Team_Member?.Tile_Image?.url}
                                    blockTitle={props?.data?.Select_Team_Member?.Name}
                                    blockContent={`We are the Kensington and Chelsea garden square specialists. Interested in selling or letting, get in touch with our team.`}
                                    blockBtn="Speak to our team"
                                    blockLink={props?.data?.Contact_Link ? GetURL(props?.data?.Contact_Link?._id) : `/about/meet-the-team/${props?.data?.Select_Team_Member?.Url}/`}
                                    blockVideo={props?.data?.Select_Team_Member?.Video_Url} 
                                />
                                </Col>
                                <Col>
                                   <OfficeBookAppointment Lets_Together_Content={Lets_Together_Content}/>
                                </Col>
                             </Row>
                            
                            </div>}
                        
                    </Row>
                    <hr/>
                    <div className="stats-section">
                       <Counter />
                    </div>
                    <div className="team-section ">
                        <Row>
                            <Col xs="12" className="d-flex flex-row justify-content-between team-list-sugg">
                                <p>
                                    Our {props?.data?.Title} Team
                                </p>
                                <Link to={`/${PageLinks.team_url}/`}>Meet the Team</Link>
                            </Col>
                            <Container>
                                <div className='event-slider'>
                                    {/* <span className='sub-title'>{props?.data?.Title}</span> */}
                                    <Slider className="slick-arrow" {...settings}>
                                         {props?.teams?.map(item => (
                                            <NewsCard 
                                                key={item._id} 
                                                id={item._id} 
                                                // index={index}
                                                imagename={`news-and-videos.Tile_Image.list_hm`}
                                                selectedVideo={selectedVideo}
                                                setSelectedVideo={(val) => setSelectedVideo(val)}
                                                newsCard={{
                                                    newsTitle: item.Title || item.Name,
                                                    newsTag: item.Sub_Category || item.Designation,
                                                    newsImg: item.Tile_Image?.url,
                                                    newsImgAlt: item.Tile_Image?.alternativeText,
                                                    newsImgTransforms: item.imagetransforms,
                                                    newsUrl: item.Url+"/",
                                                    newsVideo: true,
                                                    videoID: item.Video_Url,
                                                    id: item._id
                                                }} 
                                                video={item.Video_Url}
                                                path={`/${PageLinks.team_url}/`}
                                            />
                                        ))}
                                    </Slider>
                                </div>
                            </Container>
                            {props?.teams?.map(item => (
                                <Col xs="12" md="6" lg="4">
                                    {/* <NewsCard 
                                        key={item._id} 
                                        id={item._id} 
                                        // index={index}
                                        imagename={`news-and-videos.Tile_Image.list_hm`}
                                        selectedVideo={selectedVideo}
                                        setSelectedVideo={(val) => setSelectedVideo(val)}
                                        newsCard={{
                                            newsTitle: item.Title,
                                            newsTag: item.Sub_Category,
                                            newsImg: item.Tile_Image.url,
                                            newsImgAlt: item.Tile_Image.alternativeText,
                                            newsImgTransforms: item.imagetransforms,
                                            newsUrl: item.Url+"/",
                                            newsVideo: true,
                                            videoID: item.Video_Url,
                                            id: item._id
                                        }} 
                                        video={item.Video_Url}
                                        path={props.path}
                                    /> */}
                                    {/* <TeamCard 
                                        key={item._id} 
                                        id={item._id} 
                                        selectedVideo={selectedVideo}
                                        setSelectedVideo={(val) => setSelectedVideo(val)}
                                        teamCard={{
                                            memberPic: item.Tile_Image?.url,
                                            memberName: item.Name,
                                            memberNumber: item.Mobile,
                                            memberEmail: item.Email,
                                            memberLink: item.Url+"/",
                                            memberBio: 'Bio',
                                            blockVideo: item.Video_Url
                                        }}
                                        video={item.Video_Url}
                                        path={"/about/meet-the-team/"}
                                    /> */}
                                </Col>
                            )
                            )}
                        </Row>
                    </div>
                    <div className="content-wrapper">
                        <div>
                            {props?.data?.Static_heading && <h2 className="content-heading">{props?.data?.Static_heading}</h2>}
                            {props?.data?.Static_content && HTMLReactParser(removeEmptyHeadings(props?.data?.Static_content))}
                        </div>
                    </div>
                    <div className="faq-section">
                      <Faq data={faqModuleData} />
                    </div>
                </Container>
            </section>
            {/* <div className="map-module w-100" id="office-map">
                <GoogleMapReact
                    bootstrapURLKeys={{
                        key: process.env.GATSBY_GOOGLE_MAP_KEY
                    }}
                    defaultCenter={{
                        lat: 51.489592,
                        lng: -0.191138
                    }}
                    defaultZoom={17}
                >
                    <Marker
                        lat={props?.data?.Latitude}
                        lng={props?.data?.Longitude}
                    />
                </GoogleMapReact>
            </div> */}
            <Modal className="form-popup" onHide={() => setShow(false)} show={show} contentClassName="p-0" size="sm">

                <Modal.Body className="p-5">
                    <div className="card-title h5 text-center mb-3">Get in Touch - {props?.data?.Title}</div>
                    <button onClick={() => setShow(false)} type="button" className="close-modal">
                        <i className="icon-close-modal"></i>
                    </button> 
                    <div className="form-block career-form">
                        <ContactFormPage email={props?.data?.Email} formname={`Get in Touch - ${props?.data?.Title}`}/>
                    </div>
                </Modal.Body>
            </Modal>
             <div className={`sticky-get-in-touch d-none d-md-block ${isSticky ? "is-visible" : ""}`}>
               <a href="javascript:;" className="sticky-get-in-touch-btn" onClick={() => setShow(true)}>
                     get in touch
                 </a>
             </div>
        </React.Fragment >
    )
}
export default OfficeDetail;
